/**
 * Feature flags for the org document management dashboard (PTEC-425 §13).
 *
 * Two rather than one, deliberately. The feature ships whole — visibility and correction
 * together — which means the risky half arrives with the safe half. Splitting the flags
 * recovers that staging at runtime: if retract or replace misbehaves in production,
 * `orgDocumentMutations` goes off and the history dashboard — the part with no capacity to
 * damage anything, and the part organisations immediately depend on — keeps working. A
 * single flag would take both down together.
 *
 * Deliberately NOT gated by either flag:
 *
 * * the send-time write paths (`sendEvent`, `uploadMethod`, `recipientMembership`, the
 *   `org-sent` copy). History is not reconstructible — there is no backfill — so a flag that
 *   switched those off would create a permanent hole in the record rather than deferring a
 *   feature. They are additive and invisible until a read surface is enabled;
 * * the accept-handler hardening, which is a correctness fix to existing behaviour. Flagging
 *   it would mean shipping a known race with a switch to re-enable it.
 *
 * Both flags are temporary. Strip them once the feature is at 100% and stable: a flag left in
 * place indefinitely becomes an untested code path.
 */

/** Gates the read surfaces: document history, send history, failed sends, view copy. */
export const ORG_DOCUMENT_HISTORY_FLAG = 'org-document-history-enabled';

/** Gates everything that changes a wallet: retract, replace, verification, bulk retract. */
export const ORG_DOCUMENT_MUTATIONS_FLAG = 'org-document-mutations-enabled';
